import { Component, effect, inject, Renderer2} from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDividerModule } from '@angular/material/divider';
import { InAppNotificationsStore, SiteConfigStore } from '@program-suite/data-common';
import { Title } from '@angular/platform-browser';
import { AuthStore } from '@program-suite/data-auth';
import { RecaptchaModule } from 'ng-recaptcha';

@Component({
  imports: [
    RecaptchaModule,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatBadgeModule,
  ],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private siteConfigStore = inject(SiteConfigStore);
  private titleService = inject(Title)
  private authStore = inject(AuthStore);
  private inAppNotificationsStore = inject(InAppNotificationsStore);

  isLoggedIn = false;

  constructor(private renderer: Renderer2) {
    effect(() => {
      const config = this.siteConfigStore.siteConfig();
      this.updateBranding(config);
      this.injectLiveChatScript(config?.chatScript ?? null);
    });

    effect(() => {
      const authState = this.authStore.isAuthenticated(); // Adjust based on your AuthStore API
      this.isLoggedIn = authState;
    });
    this.authStore.setAppPortal('wholesaler');
  }
  
    private updateBranding(config: any) {
      const siteName = config?.name ?? 'Default Portal';
      this.titleService.setTitle(`${siteName} | Wholesaler Portal`);

      const faviconUrl = config?.favicon ?? ''; 
      this.setFavicon(faviconUrl);
    }



    private setFavicon(url: string) {
      const existingLink = document.querySelector('link[rel="icon"]');
      if (existingLink) {
        this.renderer.removeChild(document.head, existingLink);
      }
  
      const link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'icon');
      this.renderer.setAttribute(link, 'type', 'image/x-icon');
      this.renderer.setAttribute(link, 'href', url);
      this.renderer.appendChild(document.head, link);
    }

    private injectLiveChatScript(scriptHtml: string | null) {
      // Remove existing LiveChat script to prevent duplicates
      const existingScript = document.getElementById('livechat-script');
      if (existingScript) {
        this.renderer.removeChild(document.body, existingScript);
      }
      const existingNoscript = document.getElementById('livechat-noscript');
      if (existingNoscript) {
        this.renderer.removeChild(document.body, existingNoscript);
      }
  
      if (scriptHtml) {
        // Create a temporary div to parse the script and noscript tags
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = scriptHtml;
  
        // Find the app-root element
        const appRoot = document.querySelector('app-root');
        if (!appRoot || !appRoot.parentNode) {
          console.warn('app-root or parentNode not found');
          return;
        }
  
        // Process each child node (script and noscript)
        Array.from(tempDiv.childNodes).forEach(node => {
          if (node.nodeName === 'SCRIPT') {
            const script = this.renderer.createElement('script');
            this.renderer.setAttribute(script, 'id', 'livechat-script');
            this.renderer.setAttribute(script, 'type', 'text/javascript');
            this.renderer.setProperty(script, 'async', true);
            this.renderer.setProperty(script, 'textContent', node.textContent);
            this.renderer.appendChild(appRoot.parentNode, script);
          } else if (node.nodeName === 'NOSCRIPT') {
            const noscript = this.renderer.createElement('noscript');
            this.renderer.setAttribute(noscript, 'id', 'livechat-noscript');
            this.renderer.setProperty(noscript, 'innerHTML', (node as HTMLElement).innerHTML);
            this.renderer.appendChild(appRoot.parentNode, noscript);
          }
        });
      }
    }
}
